<template>
  <div>
    <div class="navbar">
      <van-nav-bar
        title="支付订单"
        :right-text="navtext"
        left-arrow
        :fixed="true"
        @click-right="onClickEdit"
      />
    </div>
    <div class="success-box">
      <div class="icon">
        <img src="../assets/images/order/order_img_zhifucg@2x.png" alt />
      </div>
      <p>订单支付成功！请等待平台发货</p>
    </div>
    <ul class="content">
      <li>
        <span>订单号</span>
        <span>{{order.sno}}</span>
      </li>
      <li>
        <span>付款金额</span>
        <span>￥{{order.totalAmount | moneyFilter}}</span>
      </li>
      <li>
        <span>下单时间</span>
        <span>{{order.createdTime}}</span>
      </li>
    </ul>
    <button class="my-order" @click="$router.push('/my-order')">我的订单</button>
  </div>
</template>

<script>
import { OutlineOrder } from "../request/api";
import { toMoney } from "../common/moneyFilter";
export default {
  data() {
    return {
      navtext: "我的订单",
      order: {}
    };
  },
  created() {
    this.getPayDetail();
  },
  filters: {
    moneyFilter(money) {
      return toMoney(money);
    }
  },
  methods: {
    onClickEdit() {
      this.$router.push("/my-order");
    },
    //查询订单信息
    getPayDetail() {
      let sno = this.getQueryString("sno");
      OutlineOrder(sno).then(res => {
        this.order = res.data;
      });
    },
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    }
  }
};
</script>

<style lang="less" scoped>
// 顶部导航
.van-nav-bar {
  height: 90px;
  line-height: 90px;
}
.van-nav-bar__title {
  font-size: 34px;
}
.van-nav-bar__text {
  font-size: 28px;
  color: #999;
}
.van-nav-bar__arrow {
  font-size: 50px;
  color: #585858;
}
.van-button__text {
  font-size: 24px;
}
.success-box {
  text-align: center;
  .icon {
    width: 90px;
    height: 90px;
    margin: 150px 0 40px 0;
    margin-left: 45%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.content {
  padding: 0 30px;
  margin-top: 109px;
  li {
    line-height: 60px;
    span:last-child {
      float: right;
    }
  }
}
.my-order {
  width: 690px;
  height: 96px;
  border-radius: 10px;
  background: #ff9900;
  color: #fff;
  font-size: 36px;
  border: none;
  margin: 100px 0 0 30px;
}
</style>